import Dialog from "@mui/material/Dialog";
import React, { useContext, useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { APIContext } from "../../Contexts/APIContext";
import TeamLeaderChallengeResponseControls from "../TeamLeaderView/TeamLeaderChallengeResponseControls";
import QaiChallengeResponseViewModel from "../TeamLeaderView/ViewModels/QaiChallengeResponseViewModel";

interface IQaiChallengeResponseDialogProps {
    view: string
    open: boolean
    close: () => void
    refresh: () => void
    action: string
    id: number
    name: string
    note: string
}

export default function QaiChallengeResponseDialog({ view, open, close, refresh, action, id, name, note }: IQaiChallengeResponseDialogProps) {
    const { post, showMessage, loading } = useContext(APIContext);
    const [qaiChallengeResponseViewModel, setQaiChallengeResponseViewModel] = useState<QaiChallengeResponseViewModel>(new QaiChallengeResponseViewModel(id));

    const onChangeHandler = (e: any) => {
        setQaiChallengeResponseViewModel({
            ...qaiChallengeResponseViewModel,
            [e.target.name]: e.target.value
        })
    }

    const responseTypes = [
        'Rejected',
        'Upheld',
        'Resolved'
    ]

    const handleSubmit = () => {
        post('QaiScorecardChallenge',
            action,
            (qaiChallengeResponseViewModel),
            () => {
                close();
                refresh();
                showMessage('success', 'Response submitted')
            })
    }

    const responseChangeHandler = (e: any) => {
        setQaiChallengeResponseViewModel({
            ...qaiChallengeResponseViewModel,
            response: e.target.value
        })
    }

    return (
        <Dialog open={open} fullWidth maxWidth='sm'>
            <ValidatorForm onSubmit={handleSubmit}>
                <Grid container height={view === 'Team Leader' ? '550px' : '484px'} padding={1}>
                    <Grid container size={12} marginBottom='22px'>
                        <Grid size={12}>
                            <Typography><b>Name:</b></Typography>
                            <Typography>{name}</Typography>
                        </Grid>
                        <Grid paddingBottom={2} size={12}>
                            <Typography><b>Note:</b></Typography>
                            <Typography>{note}</Typography>
                        </Grid>
                        {
                            view === 'Team Leader' &&
                            <TeamLeaderChallengeResponseControls
                                qaiChallengeResponseViewModel={qaiChallengeResponseViewModel}
                                setQaiChallengeResponseViewModel={setQaiChallengeResponseViewModel} />
                        }
                        <Grid size={12}>
                            <SelectValidator
                                id="responseType"
                                name="state"
                                label="Response Type"
                                variant="outlined"
                                validators={['required']}
                                errorMessages={['This field is required']}
                                value={qaiChallengeResponseViewModel.state}
                                onChange={onChangeHandler}
                                fullWidth>
                                {responseTypes.map(responseTypes =>
                                    <MenuItem
                                        key={responseTypes}
                                        value={responseTypes}>
                                        {responseTypes}
                                    </MenuItem>)}
                            </SelectValidator>
                        </Grid>
                        <Grid size={12}>
                            <Typography>Note:</Typography>
                            <TextField
                                id="note"
                                onChange={responseChangeHandler}
                                value={qaiChallengeResponseViewModel.response}
                                fullWidth
                                multiline
                                rows={7}
                                placeholder="Add a note..."
                                sx={{
                                    "& fieldset": { border: 'solid 1px rgb(192,192,192)', height: "206px" },
                                }} />
                        </Grid>
                    </Grid>
                    <Grid container size={12} justifyContent='flex-end' spacing={1}>
                        <Grid><Button variant='contained' onClick={close}>Cancel</Button></Grid>
                        <Grid><Button
                            variant='contained'
                            type='submit'
                            disabled={!qaiChallengeResponseViewModel.response || loading}>Submit</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </ValidatorForm >
        </Dialog>
    )
}